import { CSSProperties } from '@mui/material/styles/createTypography';
import { Box, ThemeProvider } from '@mui/system';
import { Container, Typography, Rating } from '@mui/material';
import theme from 'src/style-system/theme';
import { Carousel } from 'react-responsive-carousel';
import { useStyles } from './useStyles';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import Image from 'next/image';
import clsx from 'clsx';
import { ReviewsCarouselType } from '@utils/types';
import { animationduration } from '@utils/data';

const praiseHands = 'https://d222i9ppxs2fqe.cloudfront.net/praiseHands.png';

interface CarouselProps {
  carouselContent: ReviewsCarouselType[];
}

const CarouselComponet = ({ carouselContent }: CarouselProps) => {
  const indicatorStyles: CSSProperties = {
    background: theme.palette.cinnamon.main,
    width: 10,
    height: 10,
    display: 'inline-block',
    margin: '0 8px',
    borderRadius: '50%',
    border: '1px solid white',
  };
  const classes = useStyles();

  return (
    <>
      <ThemeProvider theme={theme}>
        <Container maxWidth="xl" disableGutters>
          <Carousel
            autoPlay
            infiniteLoop
            interval={animationduration}
            showStatus={false}
            showThumbs={false}
            showArrows={false}
            renderIndicator={(onClickHandler, isSelected, index, label) => {
              if (isSelected) {
                return (
                  <li
                    style={{
                      ...indicatorStyles,
                      background: 'white',
                    }}
                    aria-label={`Selected: ${label} ${index + 1}`}
                    title={`Selected: ${label} ${index + 1}`}
                  />
                );
              }
              return (
                <li
                  style={indicatorStyles}
                  onClick={onClickHandler}
                  onKeyDown={onClickHandler}
                  value={index}
                  key={index}
                  role="button"
                  tabIndex={0}
                  title={`${label} ${index + 1}`}
                  aria-label={`${label} ${index + 1}`}
                />
              );
            }}
          >
            {carouselContent.map((content) => {
              return (
                <Box key={content.id} className={classes.wrapper}>
                  <Box
                    className={clsx(classes.imageWrapper, classes.hideOnMobile)}
                  >
                    <Image
                      src={content.desktopIcon}
                      alt={content.alt}
                      objectFit="contain"
                      layout="fill"
                    />
                    <Box className={classes.praiseHandsImage}>
                      <Image
                        src={praiseHands}
                        alt="praiseHands"
                        objectFit="contain"
                        layout="fill"
                      />
                    </Box>
                  </Box>
                  <Box
                    className={clsx(
                      classes.imageWrapper,
                      classes.hideOnDesktop
                    )}
                  >
                    <Image
                      src={content.mobileIcon}
                      alt={content.alt}
                      objectFit="contain"
                      layout="fill"
                    />
                    <Box className={classes.praiseHandsImage}>
                      <Image
                        src={praiseHands}
                        alt="praiseHands"
                        objectFit="contain"
                        layout="fill"
                      />
                    </Box>
                  </Box>

                  <Box className={classes.contentWrapper}>
                    <Typography
                      variant="body1"
                      align="left"
                      color="white"
                      sx={{
                        position: 'relative',
                      }}
                    >
                      {content.subtitle}
                      <span>
                        <Typography
                          variant="h1"
                          align="right"
                          color="turmeric.main"
                          sx={{
                            lineHeight: '0',
                            position: 'absolute',
                            right: 0,
                            bottom: '-30px',
                          }}
                        >
                          ""
                        </Typography>
                      </span>
                    </Typography>

                    <Rating
                      readOnly
                      precision={0.5}
                      value={content.ratings}
                      sx={{
                        margin: '10px 0',
                      }}
                    />
                  </Box>
                </Box>
              );
            })}
          </Carousel>
        </Container>
      </ThemeProvider>
    </>
  );
};

export default CarouselComponet;
